var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaxDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46154 1.5H2.53846C1.68879 1.5 1 2.32655 1 3.34615V11.6538C1 12.6734 1.68879 13.5 2.53846 13.5H9.46154C10.3112 13.5 11 12.6734 11 11.6538V3.34615C11 2.32655 10.3112 1.5 9.46154 1.5Z",
    stroke: "#454D66",
    strokeOpacity: 0.7,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxDocument);
export default __webpack_public_path__ + "static/media/tax-document.01b1a8de7744e0a03c62aca8a6d4729d.svg";
export { ForwardRef as ReactComponent };